import React, { useState, useEffect, useContext } from 'react'

import SiteAccessContext from '../../../contexts/SiteAccessContext';

import { useMsal } from '@azure/msal-react';
import { fetchDataAuthenticated } from '../../../utilities/HttpUtils';
import { usePrivileges } from '../../../hooks/usePrivileges';

import useAlert from '../../Alerts/useAlert';

import '../../DataGrid.css';
import gridLogo from "../../../Images/grid.svg";
import ComponentMappingForm from './ComponentMappingForm';

// Styling
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import * as ExcelJS from 'exceljs'

function ComponentMappingGrid(props) {

    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [SelectedValue, setSelectedValue] = useState('');

    const { assignedSites } = useContext(SiteAccessContext);

    const { contributor } = usePrivileges();

    const { accounts } = useMsal();

    const { setAlert } = useAlert();

    const username = accounts[0] && accounts[0].username;

    const GroupDetails = (params) => {
        return (
            <strong>
                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => {
                    openDetailsComponent(params.row);
                }}>Details</button>
            </strong>
        )
    }
    const DeleteRow = (params) => {
        return (
            <strong>
                <button id='activate' type="button" style={{ width: "80%" }} className="btn btn-outline-primary btn-sm" 
                disabled= {!contributor ? true : params.row.active ? true : false}
                onClick={() => {
                    ActivateOrInactivateComponentLookup(params.row, true);
                }}>Active</button>

                <button id='inactivate' type="button" style={{ width: "80%" }} className="btn btn-outline-danger btn-sm" 
                disabled= {!contributor ? true : params.row.active ? false : true}
                onClick={() => {
                    ActivateOrInactivateComponentLookup(params.row, false);
                }}>Inactive</button>
            </strong>
        )
    }

    var _column = [
        {
            field: 'componentGroupName',
            headerName: 'Component Group Name',
            minwidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'siteName',
            headerName: 'Site Name',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'description',
            headerName: 'Description',
            minwidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'levelId',
            headerName: 'Level Id',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'add3PlComment',
            headerName: 'Add3PlComment',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'windowSubtractDays',
            headerName: 'Window Subtract Days',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'windowAddDays',
            headerName: 'Window Add Days',
            minwidth: 150,
            flex: 0.75,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'active',
            headerName: 'Active',
            minwidth: 100,
            flex: 0.5,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'modifiedBy',
            headerName: 'Modified By',
            minwidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'modifiedDate',
            headerName: 'ModifiedDate',
            minwidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center'
        }
    ];

    // TODO: What roles should this column be visible for?
    // props.PostData.roleId != 3
    //if (contributor) {
        _column.push(
            {
                field: '-',
                headerName: 'Details',
                width: 100,
                renderCell: GroupDetails,
                disableClickEventBubbling: true,
                headerAlign: 'center',
                align: 'center'
            });
    //}

    //if (contributor) {
        _column.push({
            field: '/',
            headerName: 'Action(Active/Inactive)',
            width: 250,
            renderCell: DeleteRow,
            disableClickEventBubbling: true,
            headerAlign: 'center',
            align: 'left'
        });
    //}

    var columns: GridColDef[] = _column;

    const openDetailsComponent = (params) => {
        setOpen(true);
        setSelectedValue(JSON.stringify(params).toString());
    };

    const openAddComponent = (params) => {
        setOpen(true);
        setSelectedValue("");
    };

    const handleFormClose = (response) => {
        if (response !== null && response === true) {
            LoadComponentMappingList();
        }
        setOpen(false);
    };

    const ActivateOrInactivateComponentLookup = async (rowData, isActive) => {

        const ComponentMapFields = {
            ComponentGroupId: rowData.componentGroupId,
            ModifiedBy: username,
            Active: isActive
        };

        await fetchDataAuthenticated(_apiUrl + 'ActiveInactiveComponent', "POST", JSON.stringify(ComponentMapFields))
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Something went wrong.');
            })
            .then(response => {
                setAlert("success", "Success", response.message);
                LoadComponentMappingList();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            });

    };

    const LoadComponentMappingList = async () => {
        let params = new URLSearchParams();

        if (assignedSites && assignedSites.length > 0) {

            assignedSites.map(si => params.append("sites", si.siteName));

            await fetchDataAuthenticated(_apiUrl + "ComponentGroupDetails?" + params.toString())
                .then(response => {
                    if (response.ok && response.status === 200) {
                        return response.json();
                    }
                    else if(response.status === 204)
                    {
                        return {};
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                })
                .catch(error => {
                    console.error(error);
                    setAlert("danger", "Error", error.message);
                });
        }
        else {
            console.error("In LoadComponentMappingList - You have no access to sites");
        }
    };
    const exportToExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('ComponentMapping');
        worksheet.addRow(['Site','ComponentGroupName','Description','LevelId','GovernmentLevelId','Add3PlComment','WindowSubtractDays','WindowAddDays','Analysis','SmComponent','OrderNumber','CustomerComponent','GovernmentComponent','DecimalPlaces']);
        tableData.forEach(row => {
            row.componentGroupDetailsInfo.forEach( detail=> {
                worksheet.addRow([row.siteName,row.componentGroupName,row.description,row.levelId,row.governmentLevelId,row.add3PlComment,row.windowSubtractDays,row.windowAddDays,detail.analysis,detail.smComponent,detail.orderNumber,detail.customerComponent,detail.governementComponent,detail.decimalPlaces])
            }
            ) 
        });
        workbook.xlsx.writeBuffer().then((buffer)=>
        {
            const blob = new Blob([buffer],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'GOMComponentMapping.xlsx';
            a.click();
        });

    };

    useEffect(() => {
        LoadComponentMappingList();
    }, [assignedSites]);

    if (!assignedSites) {
        return (
            <div className="d-flex justify-content-center">
                <p className="text-muted">You have no access to sites. Please contact your administrator.</p>
            </div>
        );
    }

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-6 titleBar'>
                    <img src={gridLogo} alt="grid logo" className="gridLogo" />
                    Component Mapping
                </div>
                <div className='col-md-3'>
                    {/*TODO: implement this correctly: props.PostData.roleId != 3*/}
                    {<button type="button" disabled= {!contributor ? true : false} className="btn btn-outline-primary btn-primary-label" onClick={openAddComponent}>Component Mapping</button>}
                </div>
                <div className='col-md-3'>
                    {<button type="button"  className="btn btn-outline-primary btn-primary-label" onClick={exportToExcel}>Export</button>}
                </div>
            </div>

            <Box sx={{ height: 375, width: '100%' }}>
                <DataGrid
                    rows={tableData}
                    columns={columns}
                    initialState={{
                        ...tableData.initialState,
                        pagination: { paginationModel: { pageSize: 20 } },
                      }}
                    pageSizeOptions={[20,50,100]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={(row: any) => row.componentGroupId + row.componentGroupName}
                />
            </Box>

            <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="md">
                <DialogTitle className="csDialogTitle">Component Mapping</DialogTitle>
                <ComponentMappingForm SelectedValueTochild={SelectedValue} PostData={props.PostData} CloseDialog={handleFormClose} />
            </Dialog>
        </div>
    );
}

export default ComponentMappingGrid;
